module.exports = __webpack_public_path__ + "static/media/Mapa-Alagoas.aff3ba45.svg";